/* Source: /home/sidsolaiyappan/skooch_ai/shared/chat_transport_resolve.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function resolveChatTransport(windowFlag, isAnon, hostname) {
  if (((windowFlag !== undefined) && (windowFlag !== null))) {
    return (windowFlag ? true : false);
  }
  if (isAnon) {
    return false;
  }
  let _host = String((hostname ? hostname : "")).toLowerCase();
  if (((_host === "localhost") || (_host === "127.0.0.1"))) {
    return true;
  }
  return false;
}
export {resolveChatTransport};
//# sourceMappingURL=chat_transport_resolve.js.map
